import { render } from "./B2bPagePlannedProcesses.vue?vue&type=template&id=6b475b90&scoped=true&lang=pug"
import script from "./B2bPagePlannedProcesses.vue?vue&type=script&lang=js"
export * from "./B2bPagePlannedProcesses.vue?vue&type=script&lang=js"

import "./B2bPagePlannedProcesses.vue?vue&type=style&index=0&id=6b475b90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b475b90"]])

export default __exports__